import React from "react"
import {NavStore} from "./stores/navStore"
import {DisStore} from "./stores/disStore"
import {LocStore} from "./stores/locStore"
import {PaginationStore} from "./stores/paginationStore"
import {InsightsStore} from "./stores/insightStore"
import {TimePeriodStore} from "./stores/timePeriodStore"
import {LocGroupStore} from "./stores/locGroupStore"
import {ModalStore} from "./stores/modalStore"
import {PoiStore} from "./stores/poiStore"
import {GTMapStore} from "./stores/gtMapStore"
import {BackdropStore} from "./stores/backdropStore"
import {InsightsPopupStore} from "./stores/insightsPopupStore"
import {AuthDataStore} from "./stores/authDataStore"

export const Stores = {
  navStore: new NavStore(),
  disStore: new DisStore(),
  locStore: new LocStore(),
  paginationStore: new PaginationStore(),
  insightStore: new InsightsStore(),
  timePeriodStore: new TimePeriodStore(),
  locGroupStore: new LocGroupStore(),
  modalStore: new ModalStore(),
  poiStore: new PoiStore(),
  gtMapStore: new GTMapStore(),
  backdropStore: new BackdropStore(),
  insightsPopupStore: new InsightsPopupStore(),
  authDataStore: new AuthDataStore(),
}

export const StoresContext = React.createContext(Stores)
